<!-- will render any type of page -->
<div class="min-h-screen bg-e-white" id="content">
  @if(!entity && !!loading.value && !isPrerendered){
  <div>
    <div class="flex flex-col container-default justify-center items-center">
      <h2 class="pb-3">{{'common.loading' | translate}}</h2>
      <app-loader></app-loader>
    </div>
  </div>
  }
  @if(!entity && !loading.value){
  <div class="container">
    <div class="row my-5">
      <img src="assets/images/ekomenu-logo-rgb-rondje.svg" height="200" width="200">
      <h1 class="text-center pt-5">{{'common.not_found' | translate}}</h1>
      <div class="row">
        <div class="col-4 text-center">
          <a class="button-base" href="/">Home</a>
        </div>
      </div>
    </div>
  </div>
  }
  @if(!!entity && !loading.value){
  <div clas="bg-e-white">

    <div class="d-none" id="staticpagecontentloaded"></div>
    @switch (entity_type) {
    @case ('STORY') {
    <app-cms-page [story]="entity"></app-cms-page>
    }
    @case ('STATICPAGE') {
    <div class="container-default mx-auto h-full-screen">
      <div class="" [innerHTML]="staticpageContent | safeHtml"></div>
    </div>
    }
    @case ('PRODUCT') {
    <app-product [product]="entity" (addOrderline)="addOrderline($event, entity, null)" (quantityChange)="changeProductSelectionQty($event, entity)"
      [orderlines]="orderlines?.value">
    </app-product>
    }
    @case ('RECIPE') {
    
    <app-cms-page [story]="recipe_topstory"></app-cms-page>

    <app-recipe [recipe]="entity" [personquantity]="persons"></app-recipe>
    <div class="relative container-default bg-e-white rounded-t-lg mb-[50px]">
      <h3 class="my-6 md:my-[50px]">{{'recipe.comparable_recipes' |translate}}</h3>
      @defer (on viewport){
      @if(entity?.lifestyles){
      <recipe-list [horizontal]="true" class="overflow-x-auto" [lifestyles]="[entity?.lifestyles.length >0 ? entity?.lifestyles[0]?.lifestyleid :null]"
        [deliverydate]="datenextweek" [pagesize]="5" [showallbtn]="false">
        <ng-template #recipe let-recipe>
          <recipecard class="flex items-stretch snap-center min-w-[340px]" [recipe]="recipe" [status]="'PROCESSED'">
          </recipecard>
        </ng-template>
      </recipe-list>
      }
      }@placeholder{
      <div class="flex flex-row gap-6 overflow-hidden">
        @for(item of [0,1,2,3,4,5,6,7,8,9]; track item){
        <app-placeholder class="h-[480px] min-w-80" preset="RECIPE"></app-placeholder>
        }
      </div>
      }
    </div>
    }
    @case ('LIFESTYLE') {
    <app-lifestyle [lifestyle]="entity" [personquantity]="persons" [recipequantity]="meals"></app-lifestyle>
    }
    @case ('BOXPAGE') {
    <app-boxpage [boxpage]="entity" [personquantity]="persons" ></app-boxpage>
    }
    @case ('BOX') {
    <app-box [box]="entity" [personquantity]="persons" (addOrderline)="addOrderline($event, null, entity)" (quantityChange)="changeProductSelectionQty($event, null, entity)"
      (personsChange)="changeBoxPersonQty($event, entity)" [orderlines]="orderlines?.value">
    </app-box>
    }
    }
  </div>
  }
</div>

@if(showScrollTop){
<button @fadeIn title="Naar boven" class="fixed bottom-5 right-5 h-11 w-11 p-3 rounded-full bg-e-reg-green hover:bg-e-mid-green z-20" (click)="scrollToTop()">
  <span class="transition-colors duration-75 h-4 hover:mt-[-3px]">
    <img class="h-[17px] -rotate-90" alt="previous slide" src="./assets/images/icons/arrow_right.svg" />
  </span>
</button>
}

@defer (on viewport){
<app-footer></app-footer>
}@placeholder{
  <app-placeholder class="h-[564px] w-full">
    <div class="flex flex-col">
      <div class="h-96 px-6 md:pl-24 w-full white">
          <div class="my-10 h-72 md:my-24 bg-slate-200 rounded-lg">
          </div>
      </div>
      <div class="h-44 w-full px-6 md:pl-24 py-16 bg-white">
        <div class="w-full h-full bg-slate-200 rounded-lg"></div>
      </div>
    </div>
  </app-placeholder>
}